// DOM-specific JS should be in this file in the same
// `export default()` style as in the commented line below

// uncomment line 7 below and the line importing this file into
//  modal.js (line 5) to run your script in the browser

// export default(() => console.log('hello from Modal!'));
import A11yDialog from 'a11y-dialog';

export const Modal = (el) => {
  const ui = {
    el
  };

  const { id } = el;

  const dialog = new A11yDialog(el);

  const addEvents = () => {
    ui.toggle.addEventListener('click', () => {
      dialog.show();
    });
  };

  const init = () => {
    ui.toggle = document.querySelector(`#opens--${id}`);
    addEvents();
  };

  init();
};

export default Modal;
